import FormActionType from '../model/form-action-type'
const {SET_FIELD_VALUE} = FormActionType
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import DraggableList from 'draggable-list'

import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './form-actions-editor.hbs'
import FormActionEditor from './form-action-editor'
import reorderAfterDrag from 'scoreboard/components/reorder-after-drag'
import constants from '../../components/constants'
const {SET_FIELD_VALUE_TYPE} = constants
const {SPECIFIC_VALUE} = SET_FIELD_VALUE_TYPE
import { sortActionsByGoToPage } from '../overview/form-director'

const FormActionsEditor = Backbone.View.extend({

	tagName: 'ul',

	className: 'form-actions-editor',

	/** @type {Form} */
	model: null,

	/** @type {FormActionEditor[]} */
	formActionEditors: null,

	/**
	 * A group of several actions which can be edited together
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model
	 *
	 * @param {FormAction[]} options.actions the actions to
	 * be edited
	 *
	 * @param {String[]} [options.allowedActionTypes] the action types which
	 * are allowed. If omitted, all action types are allowed
	 *
	 * @param {Widget} [options.currentWidget] the current widget containing this
	 * form actions editor
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formActionEditors = []
		this.on('change', () => this.finishRendering())
	},

	events: {
		'click .delete': 'onClickDelete',
		'click .add-action': 'onClickAddAction'
	},

	render: function() {
		this.$el.html(template())
		_.invokeMap(this.formActionEditors, 'remove')
		this.formActionEditors = []
		_.each(this.options.actions, this.renderAction.bind(this))
		this.toggleEmptyState()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		return this
	},

	finishRendering: function() {
		let el = this.$('.configurable-list ul')
		if (el.find('li').length == 1) {
			el.find('li').addClass('draggable-list-nodrag')
		} else {
			el.find('li').removeClass('draggable-list-nodrag')
			this.draggableList = new DraggableList(el[0])
			this.draggableList.on('move', (el, newIndex, prevIndex) => {
				reorderAfterDrag(this.formActionEditors, newIndex, prevIndex)
				this.trigger('change')
			})
		}
	},

	/** @param {FormAction} action */
	renderAction: function(action) {
		let actionView = new FormActionEditor({
			action,
			currentWidget: this.options.currentWidget,
			model: this.model,
			allowedActionTypes: this.options.allowedActionTypes,
			pageOrder: this.options.pageOrder,
			formView: this.options.formView,
		})
		this.$('.configurable-list .list').append(actionView.el)
		actionView.render()
		this.formActionEditors.push(actionView)
	},

	rerenderWidgetSelects: function() {
		_.each(this.formActionEditors, fae => fae.renderChangeWidgetIdSelect())
	},

	onClickDelete: function(e) {
		let el = this.$(e.target).closest('.form-action-editor')
		let index = el.index()
		const actionEditor = this.formActionEditors.splice(index, 1)
		_.invokeMap(actionEditor, 'remove')
		el.remove()
		this.trigger('change')
		this.toggleEmptyState()
	},

	onClickAddAction: function() {
		this.renderAction()
		this.trigger('change')
		this.toggleEmptyState()
	},

	toggleEmptyState: function() {
		this.$el.toggleClass('is-empty', this.formActionEditors.length === 0)
	},

	readFromDom: function() {
		// Use the dom elements so that the draggable list affects
		// the order of the actions
		const actions = _.map(this.$('.form-action-editor'),
			viewEl => {
				// #56631 get the view from the element's data attribute
				// so we can use the view's getData() method
				let view = $(viewEl).data('view')
				return view.getData()
			})

		_.each(actions, a => {
			// we have one select for both saved and unsaved widgets, so it is
			// possible that the id could be a tempId
			if (_.isNaN(_.parseInt(a.changeWidgetId))) {
				a.changeWidgetTempId = a.changeWidgetId
				delete a.changeWidgetId
			}

			if (a.type === SET_FIELD_VALUE && a.setFieldValueType === SPECIFIC_VALUE) {
				a.setFieldValue = a[a?.setFieldValueFieldId] || ''
			}
		})

		// #56948 - import sortActionsByGoToPage here to avoid circular
		// dependency issues
		return sortActionsByGoToPage(actions)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.formActionEditors, 'remove')
	}

}, {
	render: function({ model, el, formView, widget, allowedActionTypes, pageOrder }) {
		el = $(el)
		let formActions = new FormActionsEditor({
			model,
			el,
			allowedActionTypes,
			actions: _.get(widget, 'actions'),
			pageOrder,
			widget
		})
		el.append(formActions.el)
		formActions.render()
		formActions.on('change', () => formView.change())
		return formActions
	}
})

export default FormActionsEditor

FormActionsEditor.__filename__ = 'forms/widgets/form-actions-editor.js'
